import { Resolver, gql } from '@apollo/client';

import axios from 'axios';

interface RequestAnInvitationArgs {
    company: string;
    email: string;
    invitationsUrl: string;
    firstName: string;
    lastName: string;
}

/**
 * Request an invitation for a free trial. This integrates with the CRM in the background.
 * @param obj
 * @param args
 */
export const requestAnInvitation: Resolver = async (
    obj: Record<string, unknown>,
    args: RequestAnInvitationArgs,
): Promise<{ id: string; deal: string } | Error> => {
    const {
        company,
        email: emailArg,
        invitationsUrl,
        firstName,
        lastName,
    } = args;
    const email = emailArg.toLowerCase();

    const response = await axios({
        method: 'post',
        url: invitationsUrl,
        data: {
            company,
            email,
            first_name: firstName,
            last_name: lastName,
        },
    });

    return response.data;
};

export const REQUEST_AN_INVITATION = gql`
    mutation RequestAnInvitation(
        $company: String
        $email: String
        $invitationsUrl: String
        $firstName: String
        $lastName: String
    ) {
        requestAnInvitation(
            company: $company
            email: $email
            invitationsUrl: $invitationsUrl
            firstName: $firstName
            lastName: $lastName
        ) @client
    }
`;
